/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sales_Order_Fulfillment_Not_ResumableInputs */

const en_error_sales_order_fulfillment_not_resumable = /** @type {(inputs: Error_Sales_Order_Fulfillment_Not_ResumableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The process of this order has not stopped: there is nothing to resume.`)
};

/**
* | output |
* | --- |
* | "The process of this order has not stopped: there is nothing to resume." |
*
* @param {Error_Sales_Order_Fulfillment_Not_ResumableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_sales_order_fulfillment_not_resumable = /** @type {((inputs?: Error_Sales_Order_Fulfillment_Not_ResumableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sales_Order_Fulfillment_Not_ResumableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_sales_order_fulfillment_not_resumable(inputs)
});